
import extend from '@/utils/vuex-extend';
import { table } from '@/vuex-extend';
import { fetchList } from '@/api/pcm/supplier';
import { wait } from '@/utils/wait';

export default extend(table, {
    namespaced: true,
    state: {
        searchForm: {}
    },
    actions: {
        async getList({ state, dispatch }, payload) {
            await wait(dispatch, 'pcm.supplier.list', async function() {
                const { searchForm } = state;
                await dispatch('getData', {
                    caller: fetchList,
                    options: {
                        ...searchForm,
                        ...payload
                    }
                });
            })
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/modules/pcm/supplier/list.js